module.exports = __webpack_public_path__ + "static/img/CgoRC2JPrk-ATODcAAH04Q4_7kY033.2355882.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CgoRC2JPrk-ATODcAAH04Q4_7kY033.png
// module id = PsIy
// module chunks = 73